/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q18Inputs */

const et_faq_q18 = /** @type {(inputs: Faq_Q18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mida peaks hea turundusagentuur tegema?`)
};

const en_faq_q18 = /** @type {(inputs: Faq_Q18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What should a good marketing agency actually do?`)
};

/**
* | output |
* | --- |
* | "What should a good marketing agency actually do?" |
*
* @param {Faq_Q18Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q18 = /** @type {((inputs?: Faq_Q18Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q18Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q18(inputs)
	return en_faq_q18(inputs)
});